import { render, staticRenderFns } from "./EditBox.vue?vue&type=template&id=441b10f2&scoped=true"
import script from "./EditBox.vue?vue&type=script&lang=js"
export * from "./EditBox.vue?vue&type=script&lang=js"
import style0 from "./EditBox.vue?vue&type=style&index=0&id=441b10f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441b10f2",
  null
  
)

export default component.exports